import { Select } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

const PaymentCurrencySettings = ({
  onCurrencyChange,
  selectedCurrency,
  filterFrontStatus
}) => {
  const isCurrencyExchange = useSelector((state) => state.isCurrencyExchange);

  const [_, setSearchParams] = useSearchParams();

  const currencyList = useMemo(() => {
    if (filterFrontStatus) {
      return Object.keys(isCurrencyExchange).filter(
        (item) => isCurrencyExchange[item]?.status_front === 1
      );
    } else {
      return Object.keys(isCurrencyExchange);
    }
  }, [isCurrencyExchange, filterFrontStatus]);

  return (
    <Select
      variant={`brandPrimary`}
      value={selectedCurrency}
      onChange={(e) => {
        setSearchParams({ currency: e.target.value });
        onCurrencyChange(e.target.value);
      }}
      size="sm"
      w="150px"
    >
      {currencyList.map((option) => (
        <option key={option}>{option}</option>
      ))}
    </Select>
  );
};

export default PaymentCurrencySettings;
